import { getOrCreateDomElement } from 'components/layer/DialogUtils';
import { renderComponent } from 'utils/RenderingUtils';
import { ISuggestNextFormDialogProps } from './SuggestNextFormDialog';

export async function renderSuggestNextFormDialog(props: ISuggestNextFormDialogProps, callback?: () => void) {
  const { SuggestNextFormDialog } = await import('./SuggestNextFormDialog');

  const host = getOrCreateDomElement({
    id: 'dp-suggest-next-form-dialog-host',
  });

  const unMountDialog = () => {
    root.unmount();
    host.remove();
  };

  const { onYesButtonClick, onNoButtonClick, onClose, ...otherProps } = props;

  // extend onClose
  const dialogProps = {
    ...otherProps,
    onYesButtonClick: () => {
      unMountDialog();
      props.onYesButtonClick();
    },
    onNoButtonClick: () => {
      unMountDialog();
      props.onNoButtonClick();
    },
    onClose: () => {
      unMountDialog();
      props.onClose();
    },
  } as ISuggestNextFormDialogProps;

  const root = await renderComponent({
    container: host,
    component: <SuggestNextFormDialog {...dialogProps} />,
    autoUnmount: false,
    callback,
  });

  return root;
}
